import { __awaiter, __generator } from "tslib";
var trackingLoader = function () { return __awaiter(void 0, void 0, void 0, function () {
    var adType, _a, loader;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                adType = window.template ? 'paramount' : '';
                _a = adType;
                switch (_a) {
                    case 'paramount': return [3 /*break*/, 1];
                }
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, import(/* webpackChunkName: "tracking" */ './paramount')];
            case 2:
                loader = _b.sent();
                loader.init();
                return [2 /*return*/];
            case 3:
                {
                    return [2 /*return*/]; // load nothing
                }
                _b.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}); };
export default trackingLoader;
